var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 12,
    viewBox: "0 0 9 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    fill: "none",
    d: "M2.786 1.722H1.643A1.185 1.185 0 00.5 2.944v7.333A1.185 1.185 0 001.643 11.5h5.714A1.185 1.185 0 008.5 10.278V2.944a1.185 1.185 0 00-1.143-1.222H6.214m-3.429 0a1.185 1.185 0 001.143 1.222h1.143a1.185 1.185 0 001.143-1.222m-3.429 0A1.185 1.185 0 013.929.5h1.143a1.185 1.185 0 011.143 1.222m-3.429 5.5l1.143 1.222L6.214 6"
  })));
}

export default SvgIconClipboard;